import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/aboutHeader.jpg"; // Можна замінити на профільне фото або інший фон
import articlePdf from "../../resources/pastoral_vocation_nature.pdf"

export const PastoralVocation = () => {
    return (
        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle1Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle1Title")}</h2>

                            <p><i>{t("resourceArticle1Source")}</i><br/></p>
                            <p>{t("resourceArticle1Author")}</p>

                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticle1DownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1AnnotationHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1Annotation") }} /></p>

                            <br />
                            {/* Секція Вступу */}
                            <h3 className='menuColor'>{t("resourceArticle1Sec0")}</h3>
                            <p>{t("resourceArticle1P0_1")}</p>
                            <p>{t("resourceArticle1P0_2")}</p>

                            <br />

                            <h3 className='menuColor'>{t("resourceArticle1Sec1")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P1_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P1_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P1_3") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle1Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P2_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P2_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P2_3") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle1Sec3")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P3_1") }} /></p>

                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P3_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P3_3") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1Sec4")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P4_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P4_2") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1Sec5")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P5_1") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1Sec6")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P6_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P6_2") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1Sec7")}</h3>
                            <div dangerouslySetInnerHTML={{ __html: t("resourceArticle1P7_1") }} />

                            <br />
                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle1Copyright")}
                            </p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1BibliographyHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle1Bibliography") }} /></p>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
